"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var MSOneNote = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.ImpureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.667 1h10.667a.666.666 0 0 1 .666.667v12.667a.666.666 0 0 1-.666.666H4.666A.666.666 0 0 1 4 14.334V1.666A.667.667 0 0 1 4.667 1Z",
    fill: "#CA64EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 1.667A.667.667 0 0 0 15.333 1H4.667A.667.667 0 0 0 4 1.667v12.667a.666.666 0 0 0 .667.666H12.5L16 4.5V1.667Z",
    fill: "#CA64EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4.5h-3.5V8l1.75 1.598L16 8V4.5Z",
    fill: "#AE4BD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8h-3.5v3.5l1.75 1.697L16 11.5V8Z",
    fill: "#9332BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.5H16v2.834a.666.666 0 0 1-.666.666H12.5v-3.5Z",
    fill: "#7719AA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.334 3.5H4V13h4.334A.668.668 0 0 0 9 12.334V4.166a.669.669 0 0 0-.666-.666Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.833 4H4v9.5h3.833a.668.668 0 0 0 .667-.666V4.666A.668.668 0 0 0 7.833 4Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M7.833 4H4v8.5h3.833a.668.668 0 0 0 .667-.666V4.667A.668.668 0 0 0 7.833 4Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.333 4H4v8.5h3.333A.668.668 0 0 0 8 11.834V4.667A.668.668 0 0 0 7.333 4Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.666 4h6.667A.667.667 0 0 1 8 4.667v6.667a.666.666 0 0 1-.667.666H.667A.666.666 0 0 1 0 11.334V4.667A.667.667 0 0 1 .666 4Z",
    fill: "#7719AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 5.5h1.066l1.828 3.366c.095.145.167.262.215.35h.013a4.746 4.746 0 0 1-.03-.663V5.5H6v5h-.997L3.096 7.185a2.566 2.566 0 0 1-.194-.343h-.017c.022.242.031.485.028.728v2.93H2v-5Z",
    fill: "#fff"
  })));
});
var _default = MSOneNote;
exports["default"] = _default;